const STORAGE_KEY = 'vnls.postLoginRedirectPath';

const IGNORED_PATH_PREFIXES = ['/signin', '/setup', '/logout'];

// sessionStorage (not localStorage, not an in-memory variable) is the sweet spot here:
//   - It survives a *real* full-page navigation away from the app and back, in the same
//     tab. That's required because signOut() itself performs such a round trip: when
//     the user is signed in via the Hosted UI, Amplify's signOut() redirects to
//     Cognito's `/logout` endpoint and back to `redirectSignOut` (see
//     amplify-configure.ts) *before* SignoutPage even gets a chance to run - so a plain
//     in-memory (module-level) variable would already be gone by the time we could use it.
//     Unlike the `/oauth2/authorize` endpoint, Cognito's `/logout` endpoint has no `state`
//     param to round-trip custom data through, so the OAuth `state`/`customState` approach
//     (see auth-context-provider's `customState` handling) can't cover this hop either
//     - sessionStorage is what bridges it.
//   - Unlike localStorage, it's automatically cleared when the tab/window closes, and it's
//     never shared across tabs - so there's no risk of a stale, abandoned entry (e.g. the
//     user leaves /signin without logging in) hijacking a later, unrelated login in a
//     different tab, and no TTL bookkeeping is needed.
const storage = window.sessionStorage;

export function savePostLoginRedirectPath(path: string): void {
  if (path === '/') {
    return;
  }

  if (IGNORED_PATH_PREFIXES.some((ignored) => path.startsWith(ignored))) {
    return;
  }

  try {
    storage.setItem(STORAGE_KEY, path);
  } catch (_) {
    // storage might be unavailable (e.g. private browsing) - ignore
  }
}

export function peekPostLoginRedirectPath(): string | null {
  try {
    return storage.getItem(STORAGE_KEY);
  } catch (_) {
    return null;
  }
}

export function clearPostLoginRedirectPath(): void {
  try {
    storage.removeItem(STORAGE_KEY);
  } catch (_) {
    // ignore
  }
}
